"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var ModalIcon_1 = __importStar(require("./ModalIcon"));
var react_transition_group_1 = require("react-transition-group");
var Modal = function (_a) {
    var modalSize = _a.modalSize, title = _a.title, bodyChildren = _a.bodyChildren, footerChildren = _a.footerChildren, onClose = _a.onClose, isShown = _a.isShown;
    var getModalRoot = function () {
        var modalRoot = document.getElementById("modal-root");
        return modalRoot ? modalRoot : document.body;
    };
    return react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_transition_group_1.CSSTransition, { in: isShown, unmountOnExit: true, timeout: { enter: 0, exit: 300 } },
            react_1.default.createElement("div", { className: "pulse-modal modal-text-colour" },
                react_1.default.createElement("div", { className: "pulse-modal-content-" + modalSize + " modal-background", onClick: function (e) { return e.stopPropagation(); } },
                    react_1.default.createElement("div", { className: "pulse-modal-header modal-background" },
                        react_1.default.createElement("div", { className: "pulse-modal-header-item" },
                            react_1.default.createElement("h4", { className: "pulse-modal-title" }, title)),
                        react_1.default.createElement("div", { className: "pulse-modal-header-item" },
                            react_1.default.createElement(ModalIcon_1.default, { rootElement: "Span", icon: ModalIcon_1.IconType.Close, className: "pulse-modal-close-button", size: "Small", onClick: onClose }))),
                    react_1.default.createElement("div", { className: "pulse-modal-body" }, bodyChildren),
                    footerChildren && (react_1.default.createElement("div", { className: "pulse-modal-footer modal-background" }, footerChildren)))))), getModalRoot());
};
exports.default = Modal;
